import { motion } from 'framer-motion';
import { Mail, Phone, MapPin } from 'lucide-react';

const ContactInfoPanel = () => (
  <div className="space-y-8">
    <div>
      <h3
        className="text-2xl font-bold tracking-tight text-[#0B2A57] mb-6"
        style={{ fontFamily: 'Cabinet Grotesk' }}
        data-testid="contact-info-title"
      >
        Contact Information
      </h3>
      <div className="space-y-6">
        <motion.div
          whileHover={{ x: 8 }}
          className="flex items-start gap-4"
          data-testid="contact-phone"
        >
          <div className="flex-shrink-0 w-12 h-12 rounded-full bg-[#1E3D66]/10 flex items-center justify-center text-[#1E3D66]">
            <Phone size={20} />
          </div>
          <div>
            <div className="text-sm font-medium text-[#6B7280] mb-1">Phone</div>
            <a
              href="tel:9099967671"
              className="text-base font-semibold text-[#0B2A57] hover:text-[#1E3D66] transition-colors"
            >
              +91 90999 67671
            </a>
            <br />
            <a
              href="tel:8099975662"
              className="text-sm text-[#6B7280] hover:text-[#1E3D66] transition-colors"
            >
              +91 80999 75662
            </a>
          </div>
        </motion.div>

        <motion.div
          whileHover={{ x: 8 }}
          className="flex items-start gap-4"
          data-testid="contact-email"
        >
          <div className="flex-shrink-0 w-12 h-12 rounded-full bg-[#1E3D66]/10 flex items-center justify-center text-[#1E3D66]">
            <Mail size={20} />
          </div>
          <div>
            <div className="text-sm font-medium text-[#6B7280] mb-1">Email</div>
            <a
              href="mailto:info@taigasourcing.com"
              className="text-base font-semibold text-[#0B2A57] hover:text-[#1E3D66] transition-colors"
            >
              info@taigasourcing.com
            </a>
          </div>
        </motion.div>

        <motion.div
          whileHover={{ x: 8 }}
          className="flex items-start gap-4"
          data-testid="contact-address"
        >
          <div className="flex-shrink-0 w-12 h-12 rounded-full bg-[#1E3D66]/10 flex items-center justify-center text-[#1E3D66]">
            <MapPin size={20} />
          </div>
          <div>
            <div className="text-sm font-medium text-[#6B7280] mb-1">Address</div>
            <p className="text-base font-semibold text-[#0B2A57]">
              B.No. 28, 2nd Floor, H.No. 207,
              <br />
              Khatodra Bethi Colony, Surat, Gujarat 395002
            </p>
          </div>
        </motion.div>
      </div>
    </div>

    <div className="p-8 bg-[#fafaf9] rounded-lg border border-[#0B2A57]/10">
      <h4
        className="text-xl font-bold tracking-tight text-[#0B2A57] mb-4"
        style={{ fontFamily: 'Cabinet Grotesk' }}
      >
        Business Hours
      </h4>
      <div className="space-y-2 text-sm text-[#6B7280]">
        <div className="flex justify-between">
          <span>Monday - Friday</span>
          <span className="font-medium text-[#0B2A57]">9:00 AM - 6:00 PM IST</span>
        </div>
        <div className="flex justify-between">
          <span>Saturday</span>
          <span className="font-medium text-[#0B2A57]">9:00 AM - 2:00 PM IST</span>
        </div>
        <div className="flex justify-between">
          <span>Sunday</span>
          <span className="font-medium text-[#0B2A57]">Closed</span>
        </div>
      </div>
    </div>

    <div className="aspect-video w-full rounded-lg overflow-hidden shadow-lg">
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3720.5!2d72.83!3d21.18!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2sKhatodra%20Bethi%20Colony%2C%20Surat%2C%20Gujarat%20395002!5e0!3m2!1sen!2sin!4v1704876543210!5m2!1sen!2sin"
        width="100%"
        height="100%"
        style={{ border: 0 }}
        allowFullScreen
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        title="Taiga Sourcing Location"
        data-testid="contact-map"
      />
    </div>
  </div>
);

export default ContactInfoPanel;
